/* ===========================================================================
   haiku-logo — swap the header logo for the animated wordmark.

   Pure enhancement, and deliberately tiny: clone the inert <template> that
   snippets/haiku-logo.liquid emitted, drop it into whichever logo anchor
   sections/header.liquid rendered, and get out of the way.

     .logo-img  merchant uploaded a logo → replace the <img>
     .logo-txt  no logo uploaded        → replace the shop-name text

   Either way the anchor itself (its href, tabindex and the theme's own
   sticky/mobile sizing hooks) is left exactly where the theme put it, and
   the accessible name is preserved as visually-hidden text — an <svg>
   sprite stack has no intrinsic name.

   Idempotent, and re-run on shopify:section:load so the theme editor
   re-rendering the header section doesn't leave the stock logo behind.

   Config in window.haikuLogoConfig (see the snippet).
   ========================================================================= */

(function () {
  'use strict';

  var d = document;
  var cfg = window.haikuLogoConfig || {};

  if (cfg.enabled === false) { return; }

  function template() {
    var t = d.querySelector('template[data-hl-tpl="wordmark"]');
    return t && 'content' in t && t.content.firstElementChild
      ? t.content.firstElementChild.cloneNode(true)
      : null;
  }

  /* The anchor the theme rendered, whichever variant it chose. Scoped to
     #logo so a logo elsewhere on the page (footer, password page) is not
     caught by accident. */
  function anchor() {
    return d.querySelector('#logo .logo-img, #logo .logo-txt');
  }

  function label(a) {
    /* title is what header.liquid sets to shop.name; fall back to the text
       it was about to render, then to the brand name. */
    var t = (a.getAttribute('title') || a.textContent || '').trim();
    return t || cfg.name || 'haiku';
  }

  function mount() {
    var a = anchor();
    if (!a || a.querySelector('.haiku-logo')) { return; }

    var mark = template();
    if (!mark) { return; }

    var name = label(a);

    var sr = d.createElement('span');
    /* .visually-hidden is the theme's own utility; .hl-vh is declared in
       haiku-logo.css as a fallback in case a theme update renames it. */
    sr.className = 'visually-hidden hl-vh';
    sr.textContent = name;

    a.textContent = '';
    a.appendChild(sr);
    a.appendChild(mark);
    a.classList.add('hl-swapped');

    /* The anchor is now the only thing describing the link; make sure it
       reads as one even if the theme's utility class ever goes missing. */
    if (!a.getAttribute('aria-label')) { a.setAttribute('aria-label', name); }

    /* One-shot entrance. Removing the class on animationend means a later
       section re-render can't replay it mid-session. */
    mark.classList.add('hl-enter');
    mark.addEventListener('animationend', function onEnd(e) {
      if (e.animationName !== 'hl-enter') { return; }
      mark.classList.remove('hl-enter');
      mark.removeEventListener('animationend', onEnd);
    });
  }

  function boot() {
    try { mount(); } catch (e) { /* stock logo stays exactly as it was */ }
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor re-renders the header section — mount() is idempotent. */
  d.addEventListener('shopify:section:load', boot);
}());
